// The one-phone games: pass-and-play, Dumb Charades, Finish the Dialogue and Mat Bolna.
// Add this workstream's pages here; main.tsx renders every entry.
import type { AppRoute } from '../../routes';
import { Charades } from './Charades';
import { Dialogue } from './Dialogue';
import { GamesHub } from './GamesHub';
import { MatBolna } from './MatBolna';
import { OnePhone } from './OnePhone';

export const routes: AppRoute[] = [
  { path: '/games', element: <GamesHub /> },
  { path: '/games/one-phone', element: <OnePhone /> },
  { path: '/games/charades', element: <Charades /> },
  { path: '/games/dialogue', element: <Dialogue /> },
  { path: '/games/mat-bolna', element: <MatBolna /> },
];
